module.exports = __webpack_public_path__ + "components/flag/static/square/pe-043fd2a8e51c02a088d6ac5614eb5caa.svg";